/* This text will be displayed below in the header of the UROP projects page */

import { PageHeader } from '../../types';
import photo from './cover_photo.png';

const header: PageHeader = {
  coverPhoto: photo,
  headerStatement: `Undergraduate Research Opportunities Program (UROP) projects 
  showcase student contributions to cutting-edge robotics research at the 
  Biomimetic Robotics Lab.`,
};

export default header;